import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#475467",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Edit user" }), /* @__PURE__ */ _jsx("path", {
		d: "M7.49999 12.9167H6.24999C5.08702 12.9167 4.50554 12.9167 4.03237 13.0602C2.96704 13.3834 2.13336 14.217 1.81019 15.2824C1.66666 15.7555 1.66666 16.337 1.66666 17.5M12.0833 6.25C12.0833 8.32107 10.4044 10 8.33332 10C6.26226 10 4.58332 8.32107 4.58332 6.25C4.58332 4.17893 6.26226 2.5 8.33332 2.5C10.4044 2.5 12.0833 4.17893 12.0833 6.25ZM9.16666 17.5L11.7511 16.7616C11.8749 16.7262 11.9368 16.7085 11.9945 16.682C12.0457 16.6585 12.0945 16.6298 12.1399 16.5965C12.1911 16.5589 12.2366 16.5134 12.3276 16.4224L17.7084 11.0417C18.2837 10.4664 18.2837 9.53362 17.7083 8.95831C17.133 8.38302 16.2003 8.38303 15.625 8.95833L10.2443 14.339C10.1533 14.43 10.1078 14.4756 10.0702 14.5267C10.0368 14.5722 10.0081 14.6209 9.98462 14.6722C9.95812 14.7299 9.94043 14.7918 9.90507 14.9155L9.16666 17.5Z",
		stroke: "current",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUserEdit;
